import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import gsap from "gsap";
import "./navbar.css";
import Logo from "../../assets/Logo comap.png";

function NavBar() {
  const [scrolled, setScrolled] = useState(false);

  useEffect(() => {
    const handleScroll = () => {
      setScrolled(window.scrollY > 0);
    };
    window.addEventListener("scroll", handleScroll);
    return () => window.removeEventListener("scroll", handleScroll);
  }, []);

  useEffect(() => {
    const menuItems = document.querySelectorAll(".main-nav-link");

    menuItems.forEach((item) => {
      const underline = document.createElement("div");
      underline.classList.add("underline");
      item.parentElement.appendChild(underline);

      item.addEventListener("mouseenter", () => {
        gsap.to(underline, {
          width: "100%",
          duration: 0.3,
          ease: "power2.out",
        });
      });

      item.addEventListener("mouseleave", () => {
        gsap.to(underline, { width: "0%", duration: 0.3, ease: "power2.out" });
      });
    });

    // Cleanup on unmount
    return () => {
      menuItems.forEach((item) => {
        item.replaceWith(item.cloneNode(true));
      });
    };
  }, []);

  return (
    <nav className={`navbar ${scrolled ? "navbar--scrolled" : ""}`}>
      <div className="main-nav">
        <Link to="/">
          <img src={Logo} alt="Logo" className="logo" />
        </Link>
      </div>
      <div>
        <ul className="main-nav-list">
          <li>
            <Link className="main-nav-link" to="/about-us">
              About
            </Link>
          </li>
          <li>
            <Link className="main-nav-link" to="/services">
              Our Services
            </Link>
          </li>
          <li>
            <Link className="main-nav-link" to="/contact">
              Contact
            </Link>
          </li>
        </ul>
      </div>
    </nav>
  );
}

export default NavBar;
